export const reviewFlowSettings = [
  { name: "Direct to Review First", key: "isReviewFirst" },
  { name: "Capture Comment", key: "captureComment" },
  { name: "Capture Final Feedback", key: "captureFinalFeedback" },
  { name: "Receive Email on Payment", key: "receiveEmailOnPayment" },
];

export const paymentMethodSettings = [
  { name: "Accept Card Payments", key: "acceptCardPayments" },
  { name: "Accept QuickBooks Payments", key: "acceptQbPayments" },
  { name: "Accept Stripe Payments", key: "acceptStripePayments" },
  { name: "Accept Square Payments", key: "acceptSquarePayments" },
];

export const paymentDetailsSettings = [
  { name: "Bank Account Number", key: "bankAccountNumber" },
  { name: "Bank Routing Number", key: "bankRoutingNumber" },
  { name: "Zelle Email", key: "zelleEmail" },
];
